import { z } from 'zod'
import { Timestamp } from './common.js'

// Route reactions (👍 only for now). The `reaction_type` enum is intentionally
// widened as an open-shape enum so a future 👎 (or other reactions) can be
// added by extending this z.enum without a Mongo migration — the unique
// index in `reactions` includes reaction_type so multiple types can coexist
// per (user_id, route_id).
export const ReactionType = z.enum(['like'])
export type ReactionType = z.infer<typeof ReactionType>

export const Reaction = z.object({
  user_id: z.string().uuid(),
  route_id: z.string().uuid(),
  reaction_type: ReactionType,
  created_at: Timestamp,
})
export type Reaction = z.infer<typeof Reaction>

// POST /api/routes/:id/reactions body — currently empty (the id path segment
// carries the route, the caller is inferred from bearer, and the type is
// pinned to 'like' server-side). Kept as a schema so the surface can grow
// without changing the wire signature.
export const ReactionCreateInput = z
  .object({
    reaction_type: ReactionType.optional(),
  })
  .strict()
export type ReactionCreateInput = z.infer<typeof ReactionCreateInput>

// GET /api/routes/:id/reactions response.
export const ReactionSummary = z.object({
  count: z.number().int().nonnegative(),
  liked: z.boolean().nullable(),
})
export type ReactionSummary = z.infer<typeof ReactionSummary>

// GET /api/me/reactions response entry.
export const MyReactionRef = z.object({
  route_id: z.string().uuid(),
  reaction_type: ReactionType,
})
export type MyReactionRef = z.infer<typeof MyReactionRef>
